import { AppAvatar } from "@/shared/Components";
import { useGetProfileQuery } from "@/services/api/entities/profile";
import { handleFullName } from "@/shared/utils/handle-contacts-null";
import type { FC } from "react";
import styles from "./styles.module.scss";

export const UserInfo: FC = () => {
  const { data: profile } = useGetProfileQuery();
  const profileName = handleFullName(profile?.firstName, profile?.lastName);
  return (
    <div className={styles["user-info-container"]}>
      <AppAvatar name={profileName} image={""} />
      <p className={styles["user-name"]}>{profileName}</p>
    </div>
  );
};
